export default __webpack_public_path__ + "static/media/avatar_cheshire_cat5.91907574.mp3";